<style lang="less" scoped>
#title {
  margin: 20px;
}
</style>
<template>
  <div>
    <h2 id="title">{{$t('确认清除缓存')}}?</h2>
    <Row>
      <Button type="primary" @click="submit" size="large" icon="ios-leaf-outline" style="margin-left : 20px; width:100px">{{ $t('确定') }}</Button>
    </Row>
  </div>
</template>
<script>
import {
  cleanCache
} from '@/api/systemManage/cleanCache'

export default {
  name: 'system_user',
  data() {
    return {}
  },
  created() {

  },
  methods: {
    submit() {
      cleanCache().then(response => {
        this.$Message.success('清理成功')
        // let ipt = window.localStorage
        // ipt.clear()
      })
    }
  }
}
</script>
